import { createAction } from '@lifesize/typescript-react-redux-utils';
import { Actions } from '../constants/languageConstants';

export const changeLocale = (locale: string, save: boolean = false, reload: boolean = false) => {
  return async (dispatch: Function) => {
    await dispatch(createAction(Actions.CHANGE_LOCALE, { locale: locale, messages: {} }));
    window.location.reload();
  };
};
